import UsersManagement from '../../Admin/sections/usersManagement/UsersManagement';
import { useAdminToast } from '../../Admin/shell/AdminToastContext';

export const TrimGestionUsuariosPage = () => {
    const toast = useAdminToast();
    return <UsersManagement toast={toast} />;
};

export default TrimGestionUsuariosPage;
